module.exports = __webpack_public_path__ + "static/img/form_new1.a82e1a0f.jpg";